import React from 'react';
import { cn } from '@/helpers/utils';

type ContainerProps<E extends React.ElementType = 'section'> = {
    as?: E;
    className?: string;
    children?: React.ReactNode;
} & Omit<React.ComponentPropsWithoutRef<E>, 'as' | 'className' | 'children'>;

export default function Container<E extends React.ElementType = 'section'>({
    as,
    className,
    children,
    ...props
}: ContainerProps<E>) {
    const Tag = as || 'section';
    return (
        <Tag
            className={cn('w-full max-w-container mx-auto px-5 lg:px-12 xl:px-28', className)}
            {...props}
        >
            {children}
        </Tag>
    );
}
